import * as angular from "angular";
import { SubscriptionDataProvider } from "../../../../data-provider/subscription.dp";
import { Campaign } from "../../../../models/campaign.model";
import { Plan } from "../../../../models/plan.model";

let AdminPaymentFieldsComponent = {
    selector: "vcAdminPaymentFields",
    templateUrl:
        "/angular/components/admin/dialogs/sections/admin-payment-fields.component.html",
    bindings: {
        campaign: "=",
    },
    controller: class AdminPaymentFieldsController {
        // * bindings for typescript compiler *
        public campaign: Campaign;
        // ************************************

        private subscriptionDataProvider: SubscriptionDataProvider;
        public plans: Plan[];
        public oldPlan: boolean;

        constructor(SubscriptionDataProvider: SubscriptionDataProvider) {
            this.subscriptionDataProvider = SubscriptionDataProvider;
        }

        $onInit() {
            this.subscriptionDataProvider
                .getPlans(this.campaign.campaignid, true)
                .then((plans: Plan[]) => {
                    this.plans = plans;
                    this.oldPlan =
                        this.campaign.cpid && this.campaign.cpid != "";
                    angular.forEach(this.plans, (plan: Plan) => {
                        if (plan.cpid == this.campaign.cpid) {
                            this.oldPlan = false;
                        }
                    });
                });
        }
    },
};

angular
    .module("admin")
    .component(
        AdminPaymentFieldsComponent.selector,
        AdminPaymentFieldsComponent
    );
